/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid } from "@material-ui/core";

//custom libraries
import { CustomerSearchForm, CustomerSearchResults } from "../containers";
import { ContentSection } from "../components";

export default function CustomerSearch() {
  return (
    <Grid container className="min-content-height">
      <ContentSection fullWidth={true}>
        <CustomerSearchForm />
        <CustomerSearchResults />
      </ContentSection>
    </Grid>
  );
}
